import EntranceExitTimesTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function EntranceExitTimesPage() {
  const { attendances } = useTypedSelector((state: any) => state.Users);

  return (
    <S.Container>
      {/* Filter moved into the toolbar — nothing left for a head row to hold. */}
      <PageTitle title="Employee Entrance and Exit Times" />
      <EntranceExitTimesTable data={attendances.data} loading={attendances.loading} />
    </S.Container>
  );
}
